// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__FbnAN","language":"Footer_language__SLqzg","logo":"Footer_logo__IG7GJ","nav":"Footer_nav__RYGIu","social":"Footer_social__jqgEM"};